export default __webpack_public_path__ + "static/media/icon-tech.e2b5f23c.png";